import {RouteConfig} from "vue-router"
import Playground from "@/playground/Playground.vue"
import JdpJobIndex from "@/playground/jobs/JdpJobIndex.vue"
import JdpDashboard from "@/playground/dashboard/JdpDashboard.vue"
import JdpSingleJob from "@/playground/jobs/JdpSingleJob.vue"
import JdpJobCandidates from "@/playground/jobs/JdpJobCandidates.vue"
import JdpJobOverview from "@/playground/jobs/JdpJobOverview.vue"
import JdpAttributeManager from "@/playground/company-settings/JdpAttributeManager.vue"
import JdpCompanySettings from "@/playground/company-settings/JdpCompanySettings.vue"
import JdpTestSettings from "@/playground/company-settings/JdpTestSettings.vue"
import JdpCandidateProfile from "@/playground/jobs/JdpCandidateProfile.vue"
import JdpStageView from "@/playground/jobs/JdpStageView.vue"
import AdminPlayground from "@/playground/admin/AdminPlayground.vue"
import JdpAdminUsers from "@/playground/admin/JdpAdminUsers.vue"
import JdpAdminUnit from "@/playground/admin/JdpAdminUnit.vue"
import JdpTestAdmin from "@/playground/admin/JdpTestAdmin.vue"


export const adminPlaygroundRoutes: RouteConfig = {
    path: '/admin-playground',
    name: 'admin-playground',
    component: AdminPlayground,
    redirect: {name: 'admin-playground.users'},
    children: [
        {
            path: 'test',
            name: 'admin-playground.test',
            component: JdpTestAdmin
        },
        {
            path: 'users',
            name: 'admin-playground.users',
            component: JdpAdminUsers,
            children: [
                {
                    path: ':unit',
                    name: 'admin-playground.users.unit',
                    component: JdpAdminUnit
                },
            ]
        },
    ]
}
